import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Sprite } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../redux/store';
export const CoveringSprite = ({ texture, textureW, textureH, alpha = 1 }) => {
    const stageDimensions = useAppSelector((state) => state.gameDimensions.stageDimensions, shallowEqual);
    if (!stageDimensions) {
        return null;
    }
    const stageWidthToHeightRatio = stageDimensions.w / stageDimensions.h;
    const imageWidthToHeightRatio = textureW / textureH;
    const isWidthCropped = stageWidthToHeightRatio < imageWidthToHeightRatio;
    const renderWidth = isWidthCropped ? stageDimensions.h * imageWidthToHeightRatio : stageDimensions.w;
    const renderHeight = isWidthCropped ? stageDimensions.h : stageDimensions.w / imageWidthToHeightRatio;
    const x = isWidthCropped ? -(renderWidth - stageDimensions.w) / 2 : 0;
    const y = isWidthCropped ? 0 : -(renderHeight - stageDimensions.h) / 2;
    return (_jsx(Sprite, { texture: texture, width: renderWidth, height: renderHeight, x: x, y: y, roundPixels: true, alpha: alpha }));
};
